import * as React from "react";
const SvgInvoiceDue = props => <svg xmlns="http://www.w3.org/2000/svg" width={143} height={27} viewBox="0 0 143 27" {...props}><path fill="#A73F33" fillRule="evenodd" d="M0 0h143l-10 27H10z" /></svg>;
export default SvgInvoiceDue;